import { graphql } from "@/gql";

export const onboardingCreateOrganisationMutation = graphql(`
  mutation OnboardingCreateOrganisation(
    $input: OnboardingCreateOrganisationInput!
  ) {
    onboardingCreateOrganisation(input: $input) {
      organisation_id
      supplier_id
    }
  }
`);
